import { render, staticRenderFns } from "./browse-genres.vue?vue&type=template&id=12495590&scoped=true"
import script from "./browse-genres.vue?vue&type=script&lang=js"
export * from "./browse-genres.vue?vue&type=script&lang=js"
import style0 from "./browse-genres.vue?vue&type=style&index=0&id=12495590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12495590",
  null
  
)

export default component.exports